// eslint-disable-next-line import/named
import {createBrowserHistory} from 'history';

export const history = createBrowserHistory();
